import React from 'react';
import { CartIcon } from '@chegg-ui/theme';
import { getSignedInNavItems } from '../../../externals.retrofit';
import { SessionSpecificItems, CartLink, DesktopCoreNavGroup } from '../../../styles';
import HeaderLogoLink from '../../HeaderLogoLink.retrofit';
import { getSecondaryNavLinks } from '../../getSecondaryNavLinks.retrofit';
import DesktopCenterNav from './DesktopCenterNav';
import DesktopUserMenu from './DesktopUserMenu';
import UserInfoLoader from './UserInfoLoader';

var DesktopHeader = function DesktopHeader(_ref) {
  var navType = _ref.navType,
      envUrl = _ref.envUrl,
      activeSubLink = _ref.activeSubLink,
      cartCount = _ref.cartCount,
      user = _ref.user,
      userCourses = _ref.userCourses,
      userDataLoading = _ref.userDataLoading,
      onClickSignOut = _ref.onClickSignOut;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DesktopCoreNavGroup, null, /*#__PURE__*/React.createElement(HeaderLogoLink, {
    envUrl: envUrl
  }), /*#__PURE__*/React.createElement(DesktopCenterNav, {
    navItems: getSignedInNavItems(navType, userCourses),
    envUrl: envUrl,
    activeItem: activeSubLink
  })), userDataLoading && // when this is true, it'll hide CSPOnboarding, CartInfo and UserMenu
  true ? /*#__PURE__*/React.createElement(UserInfoLoader, null) : /*#__PURE__*/React.createElement(SessionSpecificItems, null, cartCount && cartCount > 0 ? /*#__PURE__*/React.createElement(CartLink, {
    href: "".concat(envUrl, "shoppingcart"),
    "data-test": "header-cart"
  }, /*#__PURE__*/React.createElement(CartIcon, {
    size: "medium",
    numItems: cartCount
  })) : null, /*#__PURE__*/React.createElement(DesktopUserMenu, {
    user: user,
    envUrl: envUrl,
    userLinks: getSecondaryNavLinks({
      navType: navType,
      onClickSignOut: onClickSignOut
    })
  })));
};

DesktopHeader.displayName = 'DesktopHeader';
export default DesktopHeader;